import { SectionType, SubsectionType } from 'pages/ClaimsContractsToolPage/types';
import { useCallback } from 'react';
import { useQueryParam, withDefault } from 'use-query-params';

const DEFAULT_SECTION = SectionType.Contracts;
const DEFAULT_SUBSECTION = SubsectionType.AllClaims;

const SectionTypeParam = {
  encode: (v: SectionType) => v,
  decode: (v: any) =>
    Object.keys(SectionType).includes(v) ? (v as SectionType) : DEFAULT_SECTION,
};

const SubsectionTypeParam = {
  encode: (v: SubsectionType) => v,
  decode: (v: any) =>
    Object.keys(SubsectionType).includes(v)
      ? (v as SubsectionType)
      : DEFAULT_SUBSECTION,
};

export const useContractToolQueryParams = () => {
  const [section, setSection] = useQueryParam<SectionType>(
    'section',
    withDefault(SectionTypeParam, DEFAULT_SECTION),
  );
  const [subsection, setSubsection] = useQueryParam<SubsectionType>(
    'subsection',
    withDefault(SubsectionTypeParam, DEFAULT_SUBSECTION),
  );

  const buildContractPath = useCallback(
    (id: number) => {
      return buildSingleContractPath(id, section, subsection);
    },
    [section, subsection],
  );

  return {
    section,
    setSection,
    subsection,
    setSubsection,
    buildSingleContractPath: buildContractPath,
  };
};

export function buildSingleContractPath(
  id: number,
  section: SectionType,
  subsection: SubsectionType,
): string {
  return `/contract/${id}?section=${section}&subsection=${subsection}`;
}
